import React from "react";
import PropTypes from "prop-types";
import { ERROR_MESSAGES } from "common/utils/Validation";
import styles from "./styles.module.scss";

const PasswordRequirements = ({ password, error: { message } = {} }) => {
    const isPasswordTooShort = message === ERROR_MESSAGES.PASSWORD_STILL_TOO_SHORT.message;
    const isPasswordTooSimple = message === ERROR_MESSAGES.PASSWORD_IS_TOO_COMMON.message;

    return (
        <div className={ styles.passwordRequirements }>
            <div className={ styles.errorMessage } aria-live="polite">
                { message }
            </div>
            <LengthMessage password={ password } isPasswordTooShort={ isPasswordTooShort } />
            <ComplexityMessage
                show={ password && !isPasswordTooShort }
                isPasswordTooSimple={ isPasswordTooSimple }
            />
            <ValidationMessage
                show={ (password && message) && !(isPasswordTooShort || isPasswordTooSimple) }
                errorMessage={ message }
            />
        </div>
    );
};

const LengthMessage = ({ password, isPasswordTooShort }) => {
    const validationState = password
        ? (isPasswordTooShort ? "fail" : "pass")
        : "empty";

    return (
        <div className={ `${ styles.lengthRequirement } ${ styles[validationState] }` }>
            Your password requires 8 characters.
        </div>
    );
};

const ComplexityMessage = ({ show, isPasswordTooSimple }) => {
    if (!show || !isPasswordTooSimple) {
        return null;
    }

    return (
        <div className={ `${ styles.complexityRequirement } ${ styles.fail }` }>
            Your password must not match our list of commonly used passwords.
        </div>
    );
};

const ValidationMessage = ({ show, errorMessage }) => {
    if (!show) {
        return null;
    }

    return (
        <div className={ `${ styles.validationMessage } ${ styles.fail }` }>
            { errorMessage }
        </div>
    );
};

PasswordRequirements.propTypes = {
    password: PropTypes.string,
    errorMessage: PropTypes.string
};

export default PasswordRequirements;
